import React, { useEffect, useState } from "react";
import { Page, LoadingMsg, PendingButton } from "components/common";
import { Row, Col, Button, Card, CardBody, Table, CardTitle, CardSubtitle } from "reactstrap";
import { NotificationManager } from "react-notifications";
import { LocalForm, Control } from "react-redux-form";
import GetBack from "components/refactoring/BackButton";
import { Trans, useTranslation } from "react-i18next";
import { ZatcaClient } from "services";
import { useHistory } from 'react-router-dom';
import { useXeroClient } from "hooks";
import { useForm, useFieldArray, FormProvider } from "react-hook-form";
import { DatePicker, FormGroup, Input, Select, SubmitButton } from "components/react-hook-form";
import { get_payment_methods } from "./payment_methods";

const ZatcaConfig = ({ }) => {
    const xero = useXeroClient();
    const zatca_client = ZatcaClient()
    const { t } = useTranslation();

    const methods = useForm({
        mode: "onBlur",
    });

    const { reset, control, setValue, handleSubmit, watch, getValues } = methods;

    const { fields, remove, append } = useFieldArray({
        control,
        name: "payment_methods",
        keyName: "key",
    });

    useEffect(async () => {
        const [accounts, zatca_codes] = await Promise.all([
            xero.get("accounts", { params: { raw: `Status="ACTIVE" AND (EnablePaymentsToAccount=true OR BankAccountType="BANK" OR BankAccountType="CREDITCARD" OR BankAccountType="PAYPAL")` }, }).get("data"),
            zatca_client.get("payment_methods").get('data')
        ])

        const _accounts = accounts.map((account) => ({
            account_id: account.AccountID,
            account_name: account.Name,
            zatca_code: zatca_codes.payment_methods?.find((code) => code.account_id === account.AccountID)?.zatca_code
        }))
        reset({
            payment_methods: _accounts
        })
    }, [])

    const onSubmit = (data) => {

        zatca_client.post("payment_methods/create_or_update_or_delete", {payment_methods: data.payment_methods.filter((pm) => pm.zatca_code)}).then((res) => {
            NotificationManager.success(t('Payment methods saved!'))
        }).catch((err) => {
            NotificationManager.error(t('Error saving payment methods!'))
        })
    }



    return (
        <>
            <hr />
            <h5 className="mt-5 mb-2 text-center card-title">
                <Trans>Configure Your payment methods for Zatca</Trans>
            </h5>
            <Card outline className="shadow-sm border mb-3">
                <CardBody >
                    <FormProvider {...methods}>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>
                                        <Trans>Account Name</Trans>
                                    </th>
                                    <th>
                                        <Trans>Payment means code</Trans>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {fields?.map((i, idx) => {
                                    const n = (v) => `payment_methods.${idx}.${v}`;
                                    return (
                                        <tr key={idx} >
                                            <td>
                                                <FormGroup name={n("account_name")} >
                                                    <Input
                                                        name={n("account_name")}
                                                        className="form-control"
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </td>
                                            <td>
                                                <FormGroup
                                                    name={n("zatca_code")}
                                                >
                                                    <Select style={{ minWidth: 200 }}
                                                        name={n("zatca_code")}
                                                        simpleValue
                                                        options={get_payment_methods(t)}
                                                    />
                                                </FormGroup>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                        <div className="text-right">
                            <SubmitButton color="success" onClick={handleSubmit(onSubmit)}>
                                <Trans>Update</Trans>
                            </SubmitButton>
                        </div>
                    </FormProvider>
                    <div className="hint mt-5 mb-2">
                        <CardSubtitle>
                            <span className="text-muted"><Trans>More details on payment means code on </Trans></span><a className="text-success" href="https://unece.org/fileadmin/DAM/trade/untdid/d16b/tred/tred4461.htm" target="_blank">https://unece.org/fileadmin/DAM/trade/untdid/d16b/tred/tred4461.htm</a>
                        </CardSubtitle>
                    </div>
                </CardBody>
            </Card>

        </>
    );
};

export default ZatcaConfig;
